// extracted by mini-css-extract-plugin
export var standaloneTable = "_f3-0";
export var standaloneTableWithBodyFill = "_f3-1";
export var withExtraHeader = "_f3-2";